import React from 'react';
import { connect } from 'react-redux';
import { messageIdExists } from '../../store/reducers';

import styles from './GameDrawer.scss';
import GameQuestions from 'Components/GameQuestions';
import GameSceneInfo from 'Components/GameSceneInfo';

function GameDrawer({
  gameLoaded,
  loaderInitialized,
  activeScene,
  activeSceneExists,
  slug,
  questions,
}) {
  return (
    <div className="GameDrawer" data-initialized={loaderInitialized}>
      <div className="GameDrawer__container">
        {gameLoaded && activeSceneExists ? (
          <GameSceneInfo slug={slug} scene={activeScene} />
        ) : (
          <GameQuestions slug={slug} questions={questions} theme="drawer" />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state, { slug, activeScene }) => {
  return {
    activeSceneExists: messageIdExists(
      state,
      `model.${slug}.scenes.${activeScene}.title`
    ),
  };
};

export default connect(mapStateToProps)(GameDrawer);
